import React, { useState, useEffect } from "react";
import { HTTP } from "../../api/resources";
import NotesListItem from "./NotesListItem";
import NoteForm from "./NoteForm";

const NotesList = ({ user, project = false, current_user = null }) => {
  const [notes, setNotes] = useState([]);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUpdate = () => {
    fetchNotes();
  };

  const fetchNotes = () => {
    if (!project){
      let url = `/notes.json`;

    HTTP.get(url, {
      params: { user_id: user.id },
    })
      .then((response) => {
        setNotes(response.data);
      })
      .catch(() => {
        Alert.show("error", "Could not load notes. Try again or refresh.");
      });
      return
    }

    let url = `/project/notes.json`;

    HTTP.get(url, {
      params: { project_id: user.id },
    })
      .then((response) => {
        setNotes(response.data);
      })
      .catch(() => {
        Alert.show("error", "Could not load notes. Try again or refresh.");
      });
  };

  useEffect(() => {
    setLoading(true);
    fetchNotes();
    setLoading(false);
  }, []);

  return (
    <div id="user-notes-list" className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">Notes</h4>
        </div>

        <button
          onClick={() => setEditing(true)}
          name="button"
          className="btn btn-primary"
        >
          + Add Note
        </button>
      </div>

      <div className="list-group list-group-flush">
        {loading ? (
          <div className="fa-2x justify-content-center list-group-item">
            <i className="fa fa-spinner-third fa-spin mr-2"></i>
          </div>
        ) : (
          notes.map((note) => (
            <NotesListItem
              key={note.id}
              note={note}
              handleUpdate={handleUpdate}
              project={project}
              user={current_user}
            />
          ))
        )}
      </div>

      {editing && (
        <NoteForm
          note={{ user_id: user.id, content: "" }}
          updateNote={handleUpdate}
          close={() => setEditing(false)}
          project={project}
          user={current_user}
        />
      )}
    </div>
  );
};

export default NotesList;
